import { Component, inject, OnInit, signal, WritableSignal } from '@angular/core';
import { LanguageService } from '../../Services/language.service';

@Component({
  selector: 'app-menu-footer',
  templateUrl: './menu-footer.component.html',
  styleUrl: './menu-footer.component.scss'
})
export class MenuFooterComponent implements OnInit{
  public languageService = inject(LanguageService);
  footer1: WritableSignal<string> = signal('');
  footer2: WritableSignal<string> = signal('');
  language = this.languageService.getLanguage();

  ngOnInit(): void {
    this.languageService.currentLanguage$.subscribe(() => {
      this.updateTitles();
    });
  }
  
  number = '00905441700050';
  goToInsta(){
    window.open('https://www.instagram.com/aradaistanbul/?hl=en', '_blank');
  }
  onWeb(){
    window.open('https://aradagroup.info', '_blank');
  }


  onCall() {
    //console.log("before opening phone app",this.number);
    window.open(`tel:${this.number}`); // Open dialer with phone number
  }

  private updateTitles() {
    // Update titles based on the current language in the service
    this.footer1 = this.languageService.footer1;
    this.footer2 = this.languageService.footer2;
    this.language = this.languageService.getLanguage();
  }
}
